 <template>
  <div class="w-full text-left">
    <div class="flex flex-wrap">
      <div
        v-for="(chip, index) in chipData"
        :key="index"
        class="flex items-center"
      >
        <div :class="[chipStyles]">
          <div
            class="px-2 py-1 float-left"
            :class="[chipText]"
            @click="executeClick(chip)"
          >
            {{ chip.name }}
          </div>
          <div
            v-if="showAction"
            class="cursor-pointer px-2 py-1 pull-right hover:text-danger"
            @click="deleteChip(chip, index)"
          >
            <i class="fas fa-times"></i>
          </div>
        </div>
        <div v-if="hasConditions">
          <div
            class="
              rounded-full
              h-12
              w-12
              flex
              items-center
              justify-center
              border border-primary
              mr-5
              ml-5
            "
            v-if="chipData && chipData[chipData.length - 1] != chip"
          >
            {{
              condition === 'AND'
                ? $t('frontend_groovemail_segment_and')
                : $t('frontend_groovemail_segment_or')
            }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Chip',

  props: {
    chipData: {
      required: true,
    },
    chipStyles: {
      required: false,
      default: 'rounded bg-primary text-primary-invert mr-1 mb-1',
    },
    showAction: {
      required: false,
      default: false,
    },
    hasConditions: {
      required: false,
      default: false,
    },
    condition: {
      required: false,
      default: 'AND',
    },
    chipText: {
      required: false,
      default: 'text-sm',
    },
  },

  methods: {
    /**
     * Execute an action on click of chip name.
     * @param {object} chip chip data.
     */
    executeClick(chip) {
      this.$emit('executeClick', chip);
    },

    /**
     * Validates list data and makes API call for list creation or updation.
     * @param {number} index index of chip.
     */
    deleteChip(chip, index) {
      this.$emit('deleteChip', chip, index);
    },
  },
};
</script>